import React, { lazy, Suspense } from 'react';
import { createRoot } from "react-dom/client";

const CommonHeaderImpl = lazy(() => import('./CommonHeaderImpl.js'));
const CommonNavImpl = lazy(() => import('./CommonNavImpl'));

const CommonHeader = () => {
	return (
		<Suspense fallback={<></>}>
			<CommonHeaderImpl />
		</Suspense>
	)
}
const CommonNavigation = () => {
	return (
		<Suspense fallback={<></>}>
			<CommonNavImpl />
		</Suspense>
	)
}

const navRootElement = document.getElementById("common__navigation");
const headerRootElement = document.getElementById("common__header");

if(navRootElement) {
	createRoot(navRootElement).render(<CommonNavigation />);
}

if(headerRootElement) {
	createRoot(headerRootElement).render(<CommonHeader />);
}